export const headCells = [
    {
        id: "sNo",
        numeric: false,
        disablePadding: true,
        label: "S.no",
    },
    {
        id: "packageName",
        numeric: false,
        disablePadding: false,
        label: "Package Name",
    },
    {
        id: "labName",
        numeric: false,
        disablePadding: false,
        label: "Lab Name",
    },
    {
        id: "price",
        numeric: true,
        disablePadding: false,
        label: "Price(₹)",
    },
    {
        id: "discount",
        numeric: true,
        disablePadding: false,
        label: "Discount",
    },
    {
        id: "validityPeriod",
        numeric: false,
        disablePadding: false,
        label: "Validity Period",
    },
    {
        id: "status",
        numeric: false,
        disablePadding: false,
        label: "Status",
    },
    // {
    //     id: "action",
    //     numeric: false,
    //     disablePadding: false,
    //     label: "Action",
    // },
];
